import React from 'react'
import { Field } from 'redux-form'
import { Button } from 'semantic-ui-react'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { CopyContainer, CopyCompanyContainer } from './styled'
import CopyCompanyForm from './CopyCompanyForm'
import CopyPurchasingOrgForm from './CopyPurchasingOrgForm'

const CopyForm = (props) => {
  const { valueForm, change, setShowCompanyForm, companies } = props

  return (
    <CopyContainer>
      <div className='rowFields'>
        <Field 
          name='copyType' 
          label='Copy Type' 
          require 
          type={type.select} 
          editable={valueForm.status === undefined || valueForm.status === null || valueForm.status === 0}
          options={[
            { text: 'Company', value: 'company' },
            { text: 'Purchasing Org', value: 'purchasingOrg' }
          ]}
          component={FieldInput} 
        />
        <Field 
          name='empty' 
          label='' 
          type={type.empty} 
          component={FieldInput} 
        />
      </div>
      {
        valueForm.copyType === 'company' ?
          <CopyCompanyForm
            valueForm={valueForm} 
            change={change} 
            setShowCompanyForm={setShowCompanyForm}
            companies={companies}
          />
          : null
      }
      {
        valueForm.copyType === 'purchasingOrg' ?
          <CopyPurchasingOrgForm
            valueForm={valueForm} 
            change={change} 
          />
          : null
      }
    </CopyContainer>
  )
}

export default CopyForm